import ProfileAvatar from "./ProfileAvatar";

const testimonials = [
  {
    name: "Alex Sarpong",
    role: "Patient",
    feedback:
      "Choose Rapid Lab, Their services and result are very good and fast trust me. Thanks to Tina for her wonderful service and thanks to rapid lab.i really love the place.",
    image: "",
  },
  {
    name: "Jnr Flakes",
    role: "Patient",
    feedback:
      "The trusted Diagnostic center you can trust ,  Your health is their concern. I really like the place and the workers are very friendly and nice.",
    image: "",
  },
  {
    name: "Thony Nart",
    role: "Patient",
    feedback:
      "Services are extra and super....Fast results release and test parameters very accurate.",
    image: "",
  },
];

const Testimonial = () => {
  return (
    <div className="container my-5 ">
      <h2 className="text-center mb-4 text-primary-emphasis">
        What Our Clients Say
      </h2>
      <div className="row">
        {testimonials.map((t, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <div className="card testimonial-card p-3 h-100 bg-warning-subtle">
              <div className="d-flex justify-content-center align-items-center ">
                <ProfileAvatar name={t.name} imageUrl={t.image} />
              </div>
              <div className="card-body text-center text-primary-emphasis">
                <h5 className="card-title ">{t.name}</h5>
                <p className="text-primary-emphasis">{t.role}</p>
                <p className="card-text">"{t.feedback}"</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonial;
